import * as React from 'react'

import { Localized } from '../../localization/react'
import { assertNever } from '../../utilities/assertNever'

// NOTE(@rfbotto):
// This will be extended to have more variants
// That's why im already creating the variant instead of using a single prop
export type FormatVariants = 'short'
export type TimeValue = Date | string

type FormatTimeRef = HTMLElementTagNameMap['time']

interface Props {
  variant: FormatVariants
  value: TimeValue
}

// eslint-disable-next-line no-shadow
export const FormatTime = React.forwardRef<FormatTimeRef, Props>(function FormatTime({ variant, value }, ref) {
  const date = new Date(value)
  const dateString = date.toISOString()

  switch (variant) {
    case 'short':
      return (
        <time dateTime={dateString} ref={ref}>
          <Localized id="short-format-time" params={{ date }} />
        </time>
      )
    default:
      return assertNever(variant)
  }
})

export default FormatTime
